import okiApi from '../../../api/oki-api';
import { OKI_TECHNICAL_FAILURE, OKI_SET_CAPTCHA_DATA, OKI_SET_CAPTCHA_ERROR, OKI_SET_ERROR_CODES } from '../oki-vuex';
const OKI_SET_BIRTH_PLACES = 'OKI_SET_BIRTH_PLACES';
const OKI_RESET_BIRTH_PLACES = 'OKI_RESET_BIRTH_PLACES';
const OKI_SET_SETTLEMENTS = 'OKI_SET_SETTLEMENTS';
const OKI_SET_BANK_BRANCHES = 'OKI_SET_BANK_BRANCHES';
const OKI_SET_PERSONAL_DATA = 'OKI_SET_PERSONAL_DATA';
const INTERNAL_SERVER_ERROR_CODE = 500;
const okiPersonalState = {
	success: false,
	settlements: [],
	bankBranches: [],
	birthPlaces: [],
	personalData: {}
};
const okiPersonalActions = {
	lookupBirthPlaces({ commit }, query) {
		okiApi
			.lookupBirthPlaces(query)
			.then((response) => {
				commit(OKI_SET_BIRTH_PLACES, response.data);
			})
			.catch(() => {
				commit(OKI_TECHNICAL_FAILURE);
			});
	},
	getSettlements({ commit }, zipCode) {
		okiApi
			.getSettlements(zipCode)
			.then((response) => {
				commit(OKI_SET_SETTLEMENTS, response.data);
			})
			.catch((error) => {
				commit(OKI_SET_ERROR_CODES, error.data ? [error.data.errorCode] : []);
				commit(OKI_TECHNICAL_FAILURE);
			});
	},
	resetBirthPlaces({ commit }) {
		commit(OKI_RESET_BIRTH_PLACES);
	},
	bankBranchSearch({ commit }, data) {
		okiApi.getAddressDropdowns(data).then((response) => {
			commit(OKI_SET_BANK_BRANCHES, response.data);
		});
	},
	rememberPersonalData({ commit }, data) {
		commit(OKI_SET_PERSONAL_DATA, data);
	},
	postPersonalForm({ commit, rootState, dispatch }, { personalData, captchaText, taEvent }) {
		return new Promise((resolve, reject) => {
			commit(OKI_SET_CAPTCHA_ERROR, false);
			let sentModel = {
				captcha: rootState.captcha
					? {
							captchaId: rootState.captcha.captchaId,
							captchaText
					  }
					: null,
				claim: {
					personalData,
					sessionId: rootState.sessionId
				},
				taEvent
			};
			okiApi.postForm(sentModel).then(
				(response) => {
					commit(OKI_SET_PERSONAL_DATA, sentModel.claim.personalData);
					commit(OKI_SET_CAPTCHA_DATA, null);
					commit(OKI_SET_CAPTCHA_ERROR, false);
					resolve(response.data);
				},
				(err) => {
					if (
						err &&
						err.response &&
						err.response.data &&
						!err.response.data.personalData &&
						err.response.data.captcha &&
						err.response.status != INTERNAL_SERVER_ERROR_CODE
					) {
						commit(OKI_SET_CAPTCHA_DATA, err.response.data.captcha);
						commit(OKI_SET_CAPTCHA_ERROR, true);
					} else {
						if (err.response.data.valid === false) {
							dispatch('collectErrorCodes', err.response.data, { root: true });
						}
						commit(OKI_TECHNICAL_FAILURE);
					}
					reject(err);
				}
			);
		});
	}
};
const okiPersonalMutations = {
	[OKI_SET_BIRTH_PLACES](state, birthPlaces) {
		state.birthPlaces = birthPlaces;
	},
	[OKI_RESET_BIRTH_PLACES](state) {
		state.birthPlaces = [];
	},
	[OKI_SET_SETTLEMENTS](state, settlements) {
		state.settlements = settlements;
	},
	[OKI_SET_BANK_BRANCHES](state, bankBranches) {
		state.bankBranches = bankBranches;
	},
	[OKI_SET_PERSONAL_DATA](state, personalData) {
		state.personalData = personalData;
	}
};

export default {
	state: okiPersonalState,
	mutations: okiPersonalMutations,
	actions: okiPersonalActions
};
